// distiNbox reading chrome. source_ref carries the email subject for these
// readings; no avatar, no author row — just a subject byline and an
// ingested-at timestamp above a rule.

import type { ReadingViewData } from "@bindery/ja-core";

import { ReadingBody } from "./reading-body";

export function DistinboxChrome({ data }: { data: ReadingViewData }) {
  const { reading } = data;
  return (
    <main className="mx-auto max-w-[36rem] px-6 py-16">
      <article
        itemScope
        itemType="https://schema.org/Article"
        className="text-ink"
      >
        <header>
          <h1
            itemProp="headline"
            className="font-jp-display text-ink text-2xl leading-snug font-medium"
          >
            {reading.source_ref}
          </h1>
          <time
            itemProp="datePublished"
            dateTime={reading.ingested_at}
            className="text-ink/60 mt-1 block text-xs tracking-wider uppercase"
          >
            {new Date(reading.ingested_at).toLocaleDateString()}
          </time>
        </header>

        <hr className="border-rule my-8 border-t" />

        <ReadingBody data={data} />
      </article>
    </main>
  );
}
